import NotAuthorizedPage from './container';

export default NotAuthorizedPage;
